import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { clearQualificationResponses } from '../utils/qualificationResponses';
import LegalModal from '../components/LegalModal';
import LanguageSwitch from '../components/LanguageSwitch';
import AppHeader from '../components/AppHeader';
import { useApplicantFlowPaths } from '../procedures/useApplicantFlowPaths';
import './Qualify.css';

export default function QualifyQualified() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const paths = useApplicantFlowPaths();
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <div className="qualify-page qualify-page--qualified">
      <AppHeader onBrandClick={() => navigate(paths.landing)} rightSlot={<LanguageSwitch />} fixed />

      <main className="qualify-main qualify-main--center qualify-main--qualified">
        <div className="qualified-check" aria-hidden="true">
          <div className="qualified-check-inner">
            <i className="ri-check-line qualified-check-icon" />
          </div>
        </div>
        <span className="qualify-badge qualify-badge--center qualify-badge--qualified">{t('qualify.qualifiedBadge')}</span>

        <h1 className="qualify-title qualify-title--center qualify-title--qualified">
          <Trans i18nKey="qualify.qualifiedTitle" components={{ accent: <span /> }} />
        </h1>
        <p className="qualify-sub qualify-sub--center qualify-sub--qualified">{t('qualify.qualifiedSub')}</p>

        <button type="button" className="qualify-continue qualify-continue--wide qualify-continue--qualified" onClick={() => navigate(paths.signup)}>
          <span>{t('qualify.continue')}</span>
          <i className="ri-arrow-right-line qualify-continue-arrow" aria-hidden />
        </button>

        <button
          type="button"
          className="qualify-start-over qualify-start-over--qualified"
          onClick={() => {
            clearQualificationResponses();
            navigate(paths.qualify);
          }}
        >
          <i className="ri-refresh-line" aria-hidden />
          {t('qualify.startOver')}
        </button>

        <p className="qualify-privacy qualify-privacy--qualified">
          <i className="ri-shield-check-line qualify-privacy-icon" aria-hidden />
          <span>
            <Trans
              i18nKey="qualify.qualifiedPrivacy"
              components={{
                privacy: (
                  <button
                    type="button"
                    className="qualify-privacy-link"
                    onClick={() => setPrivacyOpen(true)}
                  />
                ),
              }}
            />
          </span>
        </p>
      </main>

      <LegalModal type="privacy" open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}
